import {logger} from '@/utils/logger';
import {Storage} from './storage';

/**
 * @class LocalStorage
 */

export class LocalStorage extends Storage {
  set(key, value) {
    try {
      const serializedValue = JSON.stringify(value);
      localStorage.setItem(key, serializedValue);
    } catch (error) {
      logger.error('Set state error: ', error.message);
    }
  }
  get(key) {
    try {
      const storageValue = localStorage.getItem(key);
      return storageValue === null ? null : JSON.parse(storageValue);
    } catch (error) {
      logger.error('Set state error: ', error.message);
    }
  }
  remove(key) {
    localStorage.removeItem(key);
  }
  clear() {
    localStorage.clear();
  }
}
